var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mostraBtn)?_c('b-button',{staticClass:"ml-1",attrs:{"variant":"warning"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarVoltarEtapaContrato()}}},[_c('span',[_c('i',{staticClass:"fa fa-refresh mr-2"}),_vm._v(" Retornar para etapa anterior\n    ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }